import { ODataOperator } from 'types/OData';
import { v4 as uuid } from 'uuid';
export class DimensionFilter {
    static $inject = ['init'];
    constructor(init) {
        Object.assign(this, {
            id: uuid(),
            condition: ODataOperator.Equals,
            property: { key: '', name: '' },
            ...init,
        });
    }
    get prop() {
        if (!this.property || (!this.property.key && !this.property.name)) {
            return '';
        }
        return this.property.key || this.property.name;
    }
}
DimensionFilter.$inject = ['init'];
